import * as React from 'react';
import { Helmet } from 'react-helmet';

/** Enables NoState Prefetch
 *
 * NoState Prefetch allows Google to prefetch the HTML and assets for your webpage while a user
 * is still looking at Google Search Results.
 *
 * https://developers.google.com/web/updates/2018/07/nostate-prefetch
 * */
const EnableNoStatePrefetch = () => {
  return (
    <Helmet>
      <link rel="prerender" />
    </Helmet>
  );
};

export default EnableNoStatePrefetch;
